/* worktrigGridFields.js */

"use strict";

// Entity fields the Schedules grid feed projects beyond its visible columns.
//
// openWorkTriggerInstanceEditor hands the editor the PAGING FEED row rather than a freshly loaded
// entity, and WorkTriggerDetailsViewComponent reads from it in its constructor, before the full
// record arrives. Both delete and both pause actions read cached rows too. A field missing here
// reads as undefined with no error anywhere.
const ADDITIONAL_DATA_FIELDS = ["displayName", "isExhausted", "isPaused", "workType", "managedBy"];

module.exports = {ADDITIONAL_DATA_FIELDS};
